import { WidgetSchema } from "interfaces/widget-types";

export const widget_types = {
  Category_Grid: "CATEGORY_GRID",
  Collection_card: "COLLECTION_CARD",
  Episode_list: 'EPISODE_LISTING',
  Show_Card: "SHOW_CARD",
  Show_Carousel: "SC",
  Hero_Widget: "HW",
  Episode_Listing_Widget: 'EPISODE_LISTING',
  HomePage_Banner_Carousel: "HOMEPAGE_BANNER_CAROUSEL",
  Header_Widget: "HEADER_WIDGET",
  Video_Carousel: "VIDEO_CAROUSEL",
  Expanded_Video_Carousel : "EXPANDED_VIDEO_CAROUSEL",
  Marketing_Banner: "MARKETING_BANNER",
  Subscription_Widget: "SUBSCRIPTION_WIDGET",
  Continue_Watching: "CONTINUE_WATCHING",
  Watch_History: "WATCH_HISTORY",
  Voice_Widgets: "VOICE_WIDGETS"
}

export const CATEGORY_GRID_SCHEMA: WidgetSchema = {
  widgetCode: "CATEGORY_GRID",
  displayName: "Category Grid",
  fields: [
    { name: "name", label: "Name", type: "text", required: true },
    { name: "icon", label: "Icon", type: "file", required: true },
  ],
  itemFields: [
    { name: "title", label: "Item title", type: "text", required: true },
    { name: "icon", label: "Item icon", type: "file", required: true },
    { name: "landingUrl", label: "Landing URL", type: "url", required: true },
  ],
};

// constants/categoryGridDefaults.ts

export const CATEGORY_GRID_DEFAULTS = {
  widgetName: 'Category Grid',
  widgetTitle: '',
  widgetIcon: null as File | null,
  enabled: true,
  contentType: 'Static',
  sourceType: 'All',
  sortingMethod: 'CATEGORY PRIORITY',
  ctaLabel: 'View All Categories',
  ctaAction: 'Bottom Sheet',
};

export const SOURCE_TYPE_OPTIONS = [
        { value: 'All', label: 'All' },
        { value: 'Manual', label: 'Manual' }
    ]

export const SORTING_OPTIONS = [
        { value: 'CATEGORY PRIORITY', label: 'Category Priority' },
        { value: 'HIGHTEST ENGAGEMENT', label: 'Highest Engagement' },
        { value: 'NEWEST', label: 'Newest' }
    ]
    
export const CTA_ACTION_OPTIONS = [
        { value: 'Bottom Sheet', label: 'Bottom Sheet' }
    ]


